/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CarrierProBlockInput
 */
export interface CarrierProBlockInput {
  /**
   *
   * @type {string}
   * @memberof CarrierProBlockInput
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierProBlockInput
   */
  carrierAccountNumber?: string | null;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockInput
   */
  startNumber: number;
  /**
   *
   * @type {number}
   * @memberof CarrierProBlockInput
   */
  endNumber: number;
}

/**
 * Check if a given object implements the CarrierProBlockInput interface.
 */
export function instanceOfCarrierProBlockInput(
  value: object,
): value is CarrierProBlockInput {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("startNumber" in value) || value["startNumber"] === undefined)
    return false;
  if (!("endNumber" in value) || value["endNumber"] === undefined) return false;
  return true;
}

export function CarrierProBlockInputFromJSON(json: any): CarrierProBlockInput {
  return CarrierProBlockInputFromJSONTyped(json, false);
}

export function CarrierProBlockInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierProBlockInput {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    carrierAccountNumber:
      json["carrierAccountNumber"] == null
        ? undefined
        : json["carrierAccountNumber"],
    startNumber: json["startNumber"],
    endNumber: json["endNumber"],
  };
}

export function CarrierProBlockInputToJSON(json: any): CarrierProBlockInput {
  return CarrierProBlockInputToJSONTyped(json, false);
}

export function CarrierProBlockInputToJSONTyped(
  value?: CarrierProBlockInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    carrierAccountNumber: value["carrierAccountNumber"],
    startNumber: value["startNumber"],
    endNumber: value["endNumber"],
  };
}
